import { useEffect, useRef, useCallback } from 'react';

const DEBOUNCE_MS = 100;

export const useAutoScroll = (messagesEndRef, messages) => {
  const debounceTimerRef = useRef(null);

  const scrollToLastMessage = useCallback(
    (smooth = true) => {
      if (!messagesEndRef.current) return;

      const messagesContainer = messagesEndRef.current.previousElementSibling;
      if (!messagesContainer) return;

      const lastElement = messagesContainer.lastElementChild;
      if (!lastElement) return;

      lastElement.scrollIntoView({
        behavior: smooth ? 'smooth' : 'auto',
        block: 'start',
      });
    },
    [messagesEndRef]
  );

  useEffect(() => {
    if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    debounceTimerRef.current = setTimeout(() => scrollToLastMessage(true), DEBOUNCE_MS);
    return () => {
      if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
    };
  }, [messages, scrollToLastMessage]);

  return scrollToLastMessage;
};
